import {jwtDecode} from "jwt-decode"

export default function Decode(token) {
    try {
        const decoded = jwtDecode(token);
        return decoded;
    } catch (error) {
        return null;
    }
}